import config from '../config';
import { getCookie } from './cookies';
import handleResponse, { authHeader } from './helper';

export const createNote = async (params) => {
  const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader()
      },
      body: JSON.stringify(params)
    };
  const url = new URL(`${config.apiGeneralUrl}/notes/createNote`);
  return fetch(url, requestOptions).then(handleResponse);
}

export const getNotes = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/notes/getNotes`);
  url.searchParams.append('parent_id', params.parentId);
  url.searchParams.append('parent_type', params.parentType);

  return fetch(url, requestOptions).then(handleResponse);
}

export const uploadNoteDocument = async (params) => {
  const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader()
      },
      body: JSON.stringify(params)
    };
  const url = new URL(`${config.apiGeneralUrl}/notes/uploadNoteDocument`);
  return fetch(url, requestOptions).then(handleResponse);
}

export const deleteNote = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/notes/deleteNote/${params.noteId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const updateNote = async (params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/notes/updateNote/${params.noteId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};